module.exports = __webpack_public_path__ + "img/mood.006007e6.png";